/**
 * @(#)2019/7/12.
 * Url，用于路由验证
 * @author 许许
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import Basics from "./Basics";
import { cloneDeep } from "../../utils";
import React, { Component } from "react";
import { l } from "../../config/language";
import { YxComponent, Connection } from "../YxComponent";
import { IYxInputPropTypes } from "./IpropType/basePropType";

/*
 * @param children {ReactNode} react节点
 * @param styleParam {object} 样式参数
 * @param styleParam.width {object} 宽度  xxs,xs,sm,md,lg,xl
 * */

//默认props
let defaul = () => {
  return {
    rules: {},
    inputParam: {},
    children: "", //子节点
    styleParam: {
      width: "sm", //宽度  xxs,xs,sm,md,lg,xl
      size: "default", //大小
      type: "default", //类型
    },
  };
};
@Connection(defaul)
class Url extends YxComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  productionHtml() {
    let tmpProps = { ...this.props };
    // tmpProps.rules = cloneDeep(tmpProps.rules);
    tmpProps.rules.urlCheck = {
      //规则：以数字字母开头、中间可以是多个数字、字母、下划线或“-”，然后是“@”符号，h后面是数字字母，然后是“，”符号，加2-4个字母结尾
      pattern:
        /((https|http|ftp|rtsp|igmp|file|rtspt|rtspu):\/\/)(([a-zA-Z0-9\._-]+\.[a-zA-Z]{2,6})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,4})*(\/[a-zA-Z0-9\&%_\./-~-]*)?/,
      message: l("Url.em", this),
    };
    let classParam = {
      yx_yxInput_: "styleParam.type",
      yx_yxInput_width_: "styleParam.width",
      yx_yxInput_size_: "styleParam.size",
    };
    tmpProps.inputParam.className = this.styleParamClassName(
      tmpProps,
      classParam
    );
    let html = Basics.html(tmpProps);
    return html;
  }

  render() {
    //合并默认参数和外部参数
    return <div className="yx_yxInput_url">{this.productionHtml()}</div>;
  }
}

Url.propTypes = {
  ...IYxInputPropTypes,
};
Url.defaultProps = defaul();

export default Url;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Url.js